import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router';

import { useWorkspace } from '@/app/context';
import { filterNav, PERSONAL_NAV, SERVICES_NAV } from '@/app/navigation';
import { PageHeader } from '@/components/common/page-header';
import { RouteTabs } from '@/components/common/route-tabs';
import { useT } from '@/i18n/react';

export const Route = createFileRoute('/_app/me')({ component: PersonalLayout });

/**
 * The person's own pages: the worker's (`/me/work`, attendance, earnings…) or,
 * under `/me/services`, the provider's — one strip at a time, each listing
 * sub-views the sidebar does not ("My work", "My services").
 */
function PersonalLayout() {
  const t = useT();
  const { nav } = useWorkspace();
  const services = useLocation({
    select: (location) => location.pathname.startsWith('/me/services'),
  });
  return services ? (
    <>
      <PageHeader
        title={t('My services')}
        subtitle={t('Your page, the work you apply for, your quotes and your service jobs.')}
      />
      <RouteTabs items={filterNav(SERVICES_NAV, nav)} params={{}} label={t('My services')} />
      <Outlet />
    </>
  ) : (
    <>
      <PageHeader
        title={t('My work')}
        subtitle={t('Your work, attendance and earnings across projects.')}
      />
      <RouteTabs items={filterNav(PERSONAL_NAV, nav)} params={{}} label={t('My work')} />
      <Outlet />
    </>
  );
}
